<app-expandible-title [title]="'Associação'"></app-expandible-title>

<div>
    <span>Carteira: </span>
    <span class="font-weight-bold" >{{carteira}}</span>
</div>

<div>
    <span>Regra: </span>
    <span class="font-weight-bold">{{regra}}</span>
</div>

<div>
    <mat-slide-toggle [disabled]="true" [color]="'primary'" [checked]="data.processamentoOnlineAtivo"> Execução on-line</mat-slide-toggle>
</div>

<div>
    <span>Data início associação: </span>
    <span class="font-weight-bold">{{data?.inicio | date:"dd/MM/yyyy"}}</span>
</div>

<div>
    <span>Data fim associação: </span>
    <span class="font-weight-bold">{{data?.fim | date:"dd/MM/yyyy"}}</span>
</div>

